import React from 'react';
import {Form, Modal } from 'react-bootstrap';
import { ProjectView } from '../../pages/ProjectView';
const ShowPendingEnrollemnt = (props) => {
 const {customerData,setHavePendingEnroll} = props
const getRequestObj = ()=>{
    return {'searchKey': customerData?.accountNb ? "Account Number": "EZ Id",
            'idVal': customerData?.accountNb || customerData?.eZid}  
}

const onEnrollmentModalClose = () =>{
  props.resetCustomer()
  setHavePendingEnroll(false)
}
  
  return (
    <Modal centered size="xl" show={true} onHide={onEnrollmentModalClose} closeButton>
      <Modal.Header closeButton>
        <Form.Text>{customerData?.accountNb && `Account No: ${customerData?.accountNb}`  || customerData?.eZid && `EZ ID: ${customerData?.eZid}`} </Form.Text>
      </Modal.Header>
      <Modal.Body>
      <ProjectView hideForm={true} reqData={getRequestObj()}/>
      </Modal.Body>
    </Modal>
  )
};

export default ShowPendingEnrollemnt;
